import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

type Props = {
  displayOrder?: number;
  className?: string;
};

function Divider({ displayOrder, className }: Props) {
  const t = useTranslations('common');

  return (
    <Caption
      variant="lg-regular"
      className={clsx(styles.divider, className)}
      style={{ '--order': displayOrder } as React.CSSProperties}
    >
      {t('Separator')}
    </Caption>
  );
}

export { Divider };
